
import Image from 'next/image';
import Link from 'next/link';
export default function Logo() {
    return (
        <Link href="/">
            <Image src="https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/admin/logo.png?x-oss-process=image/resize,w_302" alt="logo" width={158} height={22} />
        </Link>
    );
}